// Lib
import React from 'react'
import { useTranslation } from 'react-i18next'
import { withFormik, useFormikContext } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import yupProduct from 'validations/yupProduct.validate'

// Include in project
import Layout from 'layouts'
import { useModalForm, useModalRecently, useProduct } from 'hooks'
import { HeadOfMasterData, ModalOfProduct, ModalRecentlyDeleted } from 'container'
import { Table } from 'component'
import styles from './index.module.scss'
import { setCloseDialog, setOpenDialog } from 'states/slice/modalDialog'
import { RootState } from 'states/store'
import { transformationDataIntoTable, ETranformationDataIntoTable } from 'utils/tranformData'

const ProductManagement: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { values, setFieldValue } = useFormikContext<any>()

  const getProductReducer = useSelector((state: RootState) => state.product)

  const { isModalOpen, handleOpen, handleClose } = useModalForm({
    productID: '',
    productBrandID: '',
    productName: '',
    productUnit_id: '',
    tagList: [],
  })

  const productList = transformationDataIntoTable({
    dataList: getProductReducer.productList,
    type: ETranformationDataIntoTable.ListProduct,
    handleOpen,
  })

  const {
    data: resProductTrachList,
    refetch: refetchProductTrashList,
    createProduct,
    updateProduct,
    deleteProduct,
    recoveryProduct,
  } = useProduct({
    pageSize: 9999,
    filter: {
      isActive: false,
    },
  })

  const productTrachList = transformationDataIntoTable({
    dataList: resProductTrachList?.items,
    type: ETranformationDataIntoTable.ListProductTrash,
  })

  const {
    isOpenModalRecently,
    handleCloseModalRecently,
    handleOpenModalRecently,
    onRecover: onRecoveryProduct,
  } = useModalRecently({
    recentlyList: values.recently.recentlyList,
    reconveryMasterData: recoveryProduct,
    refetchMasterDataTrash: refetchProductTrashList,
    refetchMasterData: getProductReducer.refetch,
  })

  return (
    <Layout open={false} section={t('productManagement.title')}>
      <div className={styles.container}>
        <HeadOfMasterData
          deletedArchive={t('productManagement.recentlyDeleted')}
          buttonName={t('productManagement.buttonProduct')}
          functionOpenModal={handleOpen}
          functionOpenRecently={handleOpenModalRecently}
        />
        <Table
          objectKey={{
            brandName: 'Brand',
            productName: 'Product Name',
            unitName: 'Unit',
            tagListHTML: 'Tags',
            action: 'Action',
          }}
          data={productList || []}
        />

        <ModalOfProduct
          openModal={isModalOpen}
          closeModal={handleClose}
          createProduct={createProduct}
          updateProduct={updateProduct}
          deleteProduct={deleteProduct}
          refetchProductList={getProductReducer.refetch}
          refetchProductTrashList={refetchProductTrashList}
        />

        <ModalRecentlyDeleted
          onClose={handleCloseModalRecently}
          isOpen={isOpenModalRecently}
          widthCol={{
            brandName: '20%',
            productName: '20%',
            unitName: '20%',
            tagListHTML: '20%',
          }}
          keyTable={{
            brandName: 'Brand',
            productName: 'Product Name',
            unitName: 'Unit',
            tagListHTML: 'Tags',
          }}
          dataTable={productTrachList || []}
          onClickRecover={() =>
            dispatch(
              setOpenDialog({
                title: t<string>('productManagement.recentlyTitle'),
                description: t<string>('productManagement.recentlyDescrip'),
                status: 'info',
                functionOnSubmit: () => {
                  onRecoveryProduct()
                  dispatch(setCloseDialog())
                  setFieldValue('recently.recentlyList', [])
                },
              }),
            )
          }
          primaryKey="productID"
        />
      </div>
    </Layout>
  )
}

const EnhancedProductManagement = withFormik({
  mapPropsToValues: () => ({
    formInput: {
      productID: '',
      productBrandID: '',
      productName: '',
      productUnit_id: '',
      tagList: [],
    },
    recently: {
      recentlyList: [],
      selectAll: '',
    },
  }),
  validationSchema: yupProduct,
  handleSubmit: () => {
    console.log('SKIP')
  },
})(ProductManagement)
export default EnhancedProductManagement
